import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class SearchFilters extends ThemeComponent {
    @Ref() form!: HTMLFormElement;
    @Ref() searchType!: HTMLInputElement;
    @Ref() sortType!: HTMLInputElement;

    @Ref() typeFilterElement!: HTMLUListElement|null;
    @Ref() sortFilterElement!: HTMLUListElement|null;

    private typeFilters!: NodeListOf<HTMLButtonElement>|null;
    private sortFilters!: NodeListOf<HTMLButtonElement>|null;

    init() {

        if (this.typeFilterElement) {
            this.typeFilters = this.typeFilterElement.querySelectorAll('button');
        }

        if (this.sortFilterElement) {
            this.sortFilters = this.sortFilterElement.querySelectorAll('button');
        }

        this.setActiveTypeFilter();
        this.applyTypeFilter();
        this.applySortFilter();
    }

    getParams() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        return params;
    }

    getActiveTypeFilter() {
        const params = this.getParams();
        let found:HTMLButtonElement|false = false;

        if (('type' in params) && this.typeFilters) {
            for (const typeFilter of this.typeFilters) {
                if (typeFilter.value === params.type) {
                    found = typeFilter;
                    break;
                }
            }
        }

        return found;
    }

    setActiveTypeFilter() {
        const activeTypeFilter = this.getActiveTypeFilter();

        if(!activeTypeFilter) {
            return;
        }

        activeTypeFilter.classList.add('active');
    }

    applyTypeFilter() {
        if (this.typeFilters) {
            for(const typeFilter of this.typeFilters) {
                this.$listen(typeFilter, 'click', () => {
                    const value = typeFilter.value;

                    if(value == '') {
                        return;
                    }

                    this.searchType.value = value;

                    this.form.submit();
                });
            }
        }
    }

    applySortFilter() {
        if (this.sortFilters) {
            for(const sortFilter of this.sortFilters) {
                this.$listen(sortFilter, 'click', () => {
                    const value = sortFilter.value;

                    if(value == '') {
                        return;
                    }

                    this.sortType.value = value;
                    this.form.submit();
                });
            }
        }
    }
}
